;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"e1c60dd517097ed8dcb2c7571ca5cd8d7948eb0f"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.4.3";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/admin/clients/:clientId\",\"regex\":\"^/admin/clients/([^/]+)$\",\"paramNames\":[\"clientId\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/templates/:templateKey\",\"regex\":\"^/admin/templates/([^/]+)$\",\"paramNames\":[\"templateKey\"],\"hasOptionalPrefix\":false},{\"path\":\"/contact/:publicId\",\"regex\":\"^/contact/([^/]+)$\",\"paramNames\":[\"publicId\"],\"hasOptionalPrefix\":false},{\"path\":\"/dashboard/estimate-forms/:formId\",\"regex\":\"^/dashboard/estimate-forms/([^/]+)$\",\"paramNames\":[\"formId\"],\"hasOptionalPrefix\":false},{\"path\":\"/dashboard/leads/:leadId\",\"regex\":\"^/dashboard/leads/([^/]+)$\",\"paramNames\":[\"leadId\"],\"hasOptionalPrefix\":false},{\"path\":\"/dashboard/leads/incomplete/:partialId\",\"regex\":\"^/dashboard/leads/incomplete/([^/]+)$\",\"paramNames\":[\"partialId\"],\"hasOptionalPrefix\":false},{\"path\":\"/q/:slug\",\"regex\":\"^/q/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/q/:slug/:formSlug\",\"regex\":\"^/q/([^/]+)/([^/]+)$\",\"paramNames\":[\"slug\",\"formSlug\"],\"hasOptionalPrefix\":false},{\"path\":\"/review/:token\",\"regex\":\"^/review/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/setup/:slug\",\"regex\":\"^/setup/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/setup/:slug/contact-forms\",\"regex\":\"^/setup/([^/]+)/contact-forms$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/setup/:slug/developer\",\"regex\":\"^/setup/([^/]+)/developer$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/setup/:slug/domain\",\"regex\":\"^/setup/([^/]+)/domain$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/upload/:token\",\"regex\":\"^/upload/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/about\",\"regex\":\"^/([^/]+)/about$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/analytics\",\"regex\":\"^/([^/]+)/analytics$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/contact\",\"regex\":\"^/([^/]+)/contact$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/contact-forms\",\"regex\":\"^/([^/]+)/contact-forms$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/cookies\",\"regex\":\"^/([^/]+)/cookies$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/data-processing-addendum\",\"regex\":\"^/([^/]+)/data-processing-addendum$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/developers\",\"regex\":\"^/([^/]+)/developers$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/enquiry-management-software-for-trade-businesses\",\"regex\":\"^/([^/]+)/enquiry-management-software-for-trade-businesses$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/follow-up-automation\",\"regex\":\"^/([^/]+)/follow-up-automation$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/google-reviews\",\"regex\":\"^/([^/]+)/google-reviews$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/guides/price-estimator-completion\",\"regex\":\"^/([^/]+)/guides/price-estimator-completion$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/guides/price-estimator-placement\",\"regex\":\"^/([^/]+)/guides/price-estimator-placement$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/integrations/fergus\",\"regex\":\"^/([^/]+)/integrations/fergus$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/integrations/servicem8\",\"regex\":\"^/([^/]+)/integrations/servicem8$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/integrations/simpro\",\"regex\":\"^/([^/]+)/integrations/simpro$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/integrations/tradify\",\"regex\":\"^/([^/]+)/integrations/tradify$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/lost-reactivation\",\"regex\":\"^/([^/]+)/lost-reactivation$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/pricing\",\"regex\":\"^/([^/]+)/pricing$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/privacy\",\"regex\":\"^/([^/]+)/privacy$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/resources\",\"regex\":\"^/([^/]+)/resources$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/resources/online-price-estimator-for-trade-businesses\",\"regex\":\"^/([^/]+)/resources/online-price-estimator-for-trade-businesses$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/resources/strelve-and-job-management-software\",\"regex\":\"^/([^/]+)/resources/strelve-and-job-management-software$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/resources/trade-enquiry-management\",\"regex\":\"^/([^/]+)/resources/trade-enquiry-management$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false},{\"path\":\"/:market/terms\",\"regex\":\"^/([^/]+)/terms$\",\"paramNames\":[\"market\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/forgot-password\"},{\"path\":\"/login\"},{\"path\":\"/signup\"},{\"path\":\"/signup/checkout\"},{\"path\":\"/signup/confirm\"},{\"path\":\"/signup/professional-checkout\"},{\"path\":\"/admin\"},{\"path\":\"/admin/audit\"},{\"path\":\"/admin/clients\"},{\"path\":\"/admin/clients/new\"},{\"path\":\"/admin/contact-intakes\"},{\"path\":\"/admin/data-vault\"},{\"path\":\"/admin/email-library\"},{\"path\":\"/admin/health\"},{\"path\":\"/admin/leads\"},{\"path\":\"/admin/metrics\"},{\"path\":\"/admin/settings\"},{\"path\":\"/admin/setup-insights\"},{\"path\":\"/admin/sms-usage\"},{\"path\":\"/admin/templates\"},{\"path\":\"/admin/users\"},{\"path\":\"/auth/accept-invite\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/dashboard\"},{\"path\":\"/dashboard/analytics\"},{\"path\":\"/dashboard/automations\"},{\"path\":\"/dashboard/contact-intakes\"},{\"path\":\"/dashboard/distribution-analytics\"},{\"path\":\"/dashboard/estimate-forms\"},{\"path\":\"/dashboard/franchise-recipients\"},{\"path\":\"/dashboard/leads\"},{\"path\":\"/dashboard/messaging\"},{\"path\":\"/dashboard/reactivation\"},{\"path\":\"/dashboard/settings\"},{\"path\":\"/dashboard/settings/api\"},{\"path\":\"/dashboard/settings/integrations\"},{\"path\":\"/dashboard/setup\"},{\"path\":\"/distribution/outcome\"}],\"isrRoutes\":[]}";import * as Sentry from "@sentry/nextjs";
import { isSentryEnabled, sentryTracesSampleRate } from "@/lib/sentry-config";
import { scrubBreadcrumb, scrubLog, scrubPii, scrubReplayEvent, scrubTransaction } from "@/lib/sentry-scrub";
import { safeDashboardPath } from "@/lib/dashboard-performance";

// Marketing/public routes have minimal client JS and don't benefit from Sentry
// session replay. Skip the replay integration on those routes to avoid adding
// replay overhead (~140 KB gz shared chunk) to visitor page loads.
// Note: instrumentation-client.ts always executes (Next.js App Router limitation
// — there is no per-route lazy loading here), so we gate replay at init time.
const isAuthenticatedRoute =
  typeof window !== "undefined" &&
  (window.location.pathname.startsWith("/dashboard") ||
    window.location.pathname.startsWith("/admin") ||
    window.location.pathname.startsWith("/auth"));
function isDashboardRoute(): boolean {
  return typeof window !== "undefined" &&
    (window.location.pathname.startsWith("/dashboard") ||
      window.location.pathname.startsWith("/admin"));
}

type DashboardInteraction = {
  startedAt: number;
  route: string;
  kind: "page_load" | "dashboard_navigation" | "dashboard_tab" | "admin_tab" | "analytics_tab" | "router_navigation";
};

const MAX_DASHBOARD_TIMING_EVENTS = 8;
const dashboardTimingEventKeys = new Set<string>();
let dashboardTimingEventCount = 0;
let dashboardPerformanceTracingStarted = false;
let dashboardInteraction: DashboardInteraction = {
  startedAt: 0,
  route: typeof window === "undefined" ? "/dashboard" : safeDashboardPath(window.location.pathname),
  kind: "page_load",
};

function safeResourceName(pathname: string): string | null {
  if (pathname.startsWith("/api/")) {
    return pathname
      .replace(/\/(review-feedback|review-interaction|upload|review|r|intake)\/[^/]+(?=\/|$)/gi, "/$1/[token]")
      .replace(/\/hooks?\/[^/]+(?=\/|$)/gi, "/hooks/[token]")
      .replace(/\/client_[^/]+(?=\/|$)/gi, "/[client]")
      .replace(/\/[0-9a-f-]{36}(?=\/|$)/gi, "/[id]")
      .replace(/\/\d{6,}(?=\/|$)/g, "/[id]");
  }
  if (pathname.startsWith("/_next/static/") && pathname.endsWith(".js")) return "next_script";
  if (pathname.startsWith("/dashboard") || pathname.startsWith("/admin")) {
    return safeDashboardPath(pathname);
  }
  return null;
}

function captureDashboardTiming(message: string, timingType: string, key: string, extra: Record<string, string | number>): void {
  if (
    !isDashboardRoute() ||
    dashboardTimingEventCount >= MAX_DASHBOARD_TIMING_EVENTS ||
    dashboardTimingEventKeys.has(key)
  ) {
    return;
  }

  dashboardTimingEventKeys.add(key);
  dashboardTimingEventCount += 1;

  try {
    Sentry.captureMessage(message, {
      level: "warning",
      tags: {
        component: "dashboard-client-performance",
        timing_type: timingType,
        route: dashboardInteraction.route,
        interaction_kind: dashboardInteraction.kind,
      },
      extra: {
        ...extra,
      },
    });
  } catch {
    // Performance diagnostics must never interfere with dashboard rendering.
  }
}

function resetDashboardTimingEvents(): void {
  dashboardTimingEventKeys.clear();
  dashboardTimingEventCount = 0;
}

function startDashboardPerformanceTracing(force = false): void {
  if (dashboardPerformanceTracingStarted || (!force && !isDashboardRoute())) return;
  if (typeof PerformanceObserver === "undefined") return;
  dashboardPerformanceTracingStarted = true;

  document.addEventListener("click", (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const tab = target?.closest('[role="tab"]');
    if (
      tab &&
      (window.location.pathname.startsWith("/dashboard") ||
        window.location.pathname.startsWith("/admin"))
    ) {
      resetDashboardTimingEvents();
      dashboardInteraction = {
        startedAt: performance.now(),
        route: safeDashboardPath(window.location.pathname),
        kind: window.location.pathname === "/dashboard/analytics"
          ? "analytics_tab"
          : window.location.pathname.startsWith("/admin")
            ? "admin_tab"
            : "dashboard_tab",
      };
      return;
    }

    const link = target?.closest("a[href]");
    if (!(link instanceof HTMLAnchorElement)) return;
    const route = safeDashboardPath(link.href);
    if (route !== "/other") {
      resetDashboardTimingEvents();
      dashboardInteraction = { startedAt: performance.now(), route, kind: "dashboard_navigation" };
    }
  }, true);

  const resourceObserver = new PerformanceObserver((list) => {
    if (!isDashboardRoute()) return;
    for (const entry of list.getEntries()) {
      if (!(entry instanceof PerformanceResourceTiming)) continue;

      let resourceUrl: URL;
      try {
        resourceUrl = new URL(entry.name, window.location.origin);
      } catch {
        continue;
      }
      if (resourceUrl.origin !== window.location.origin) continue;
      const resource = safeResourceName(resourceUrl.pathname);
      if (!resource) continue;
      if (
        dashboardInteraction.kind !== "page_load" &&
        entry.startTime < dashboardInteraction.startedAt
      ) {
        continue;
      }

      const startDelayMs = Math.max(0, Math.round(entry.startTime - dashboardInteraction.startedAt));
      const durationMs = Math.round(entry.duration);
      if (startDelayMs < 2_000 && durationMs < 1_500) continue;

      const resourceKind = resource.startsWith("/api/")
        ? "api"
        : resource === "next_script"
          ? "script"
          : "route";
      captureDashboardTiming(
        "Slow dashboard client resource",
        `resource_${resourceKind}`,
        `${resourceKind}:${resource}:${Math.floor(startDelayMs / 1_000)}`,
        { resource, request_start_delay_ms: startDelayMs, duration_ms: durationMs },
      );
    }
  });

  try {
    resourceObserver.observe({ type: "resource", buffered: true });
  } catch {
    // Resource timing is not available in every browser.
  }

  try {
    const longTaskObserver = new PerformanceObserver((list) => {
      if (!isDashboardRoute()) return;
      for (const entry of list.getEntries()) {
        const durationMs = Math.round(entry.duration);
        if (durationMs < 1_000) continue;
        if (
          dashboardInteraction.kind !== "page_load" &&
          entry.startTime < dashboardInteraction.startedAt
        ) {
          continue;
        }

        captureDashboardTiming(
          "Long dashboard main-thread task",
          "main_thread",
          `longtask:${Math.floor(entry.startTime / 1_000)}`,
          { duration_ms: durationMs },
        );
      }
    });
    longTaskObserver.observe({ type: "longtask", buffered: true });
  } catch {
    // Long-task timing is not available in every browser.
  }
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  enabled: isSentryEnabled(),

  tracesSampleRate: sentryTracesSampleRate(),

  // Disable client-side session envelopes. The /monitoring tunnel rejects
  // browser session envelopes with 403 ("Cors"), which logged console errors
  // on every production page view and failed the Lighthouse
  // browser-errors check. Error events pass the tunnel fine.
  integrations: (defaultIntegrations) => {
    return defaultIntegrations.filter(
      (integration) => integration.name !== "BrowserSession",
    );
  },

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: isAuthenticatedRoute ? 1.0 : 0,

  // Remove visitor PII and credentials from every Sentry event type.
  sendDefaultPii: false,
  beforeBreadcrumb: scrubBreadcrumb,
  beforeSend: scrubPii,
  beforeSendTransaction: scrubTransaction,
  beforeSendLog: scrubLog,
  enableLogs: true,

  ignoreErrors: [
    "undefined is not an object (evaluating 'window.webkit.messageHandlers')",
    /Object Not Found Matching Id:\d+, MethodName:(update|delete|insert|upsert|rpc), ParamCount:\d+/,
  ],
});

// Replay is loaded conditionally (docs recommend addIntegration for that) so
// the ~37KB-gz rrweb core stays out of the eager Sentry chunk that every
// public page downloads. Dashboard-only: replay sampling is 0 elsewhere.
if (isAuthenticatedRoute) {
  void import("@sentry/nextjs")
    .then(({ replayIntegration, getClient }) => {
      if (!getClient()) return;
      getClient()!.addIntegration(
        replayIntegration({
          maskAllText: true,
          maskAllInputs: true,
          networkCaptureBodies: false,
          beforeAddRecordingEvent: scrubReplayEvent,
        }),
      );
    })
    .catch(() => {
      // Replay is optional diagnostics; never block the page on its failure.
    });
}

startDashboardPerformanceTracing();

export function onRouterTransitionStart(
  ...args: Parameters<typeof Sentry.captureRouterTransitionStart>
) {
  Sentry.captureRouterTransitionStart(...args);

  const [url] = args;
  const targetPath = safeDashboardPath(url);
  if (targetPath === "/other") return;

  dashboardInteraction = {
    startedAt: performance.now(),
    route: targetPath,
    kind: "router_navigation",
  };
  resetDashboardTimingEvents();
  startDashboardPerformanceTracing(true);
}
